'use client';

import { useAppSelector } from '@/hooks/reduxHooks';
import { ActionButton } from '@/shared/ActionButton';
import { SelectedPage } from '@/types/types';
import { BriefcaseIcon } from '@heroicons/react/24/outline';
import { Box, rem } from '@mantine/core';
/* import { FloatingShadow } from './FloatingShadow'; */

export const TitleBox = () => {
  const theme = useAppSelector((state) => state.theme.theme);

  const icon = (
    <BriefcaseIcon
      style={{ width: rem(14), height: rem(14), marginBottom: rem(2) }}
    />
  );

  return (
    <Box className="flex h-full w-full overflow-visible ">
      <Box className="flex h-full w-full flex-col  items-center justify-center md:items-start md:justify-start ">
        <Box className="flex h-full w-full flex-col items-center justify-center md:justify-start text-center md:text-left md:items-start">
          {/* <FloatingShadow>
            <p>ULTIMATELY DEEP RESEARCH </p>
          </FloatingShadow> */}
          <p className="text-center md:text-left font-montserrat font-extrabold tracking-wide text-secondary-500 text-[4rem] md:text-[3rem] lg:text-[4rem] xl:text-[5rem] dark:text-lightBlue-200 leading-tight">
            SYSTEMATIC<br />STRATEGIES
          </p>
          <h1 className="sr-only">Arcanis - Deep Research for Venture Investing</h1>
          <p className="mt-3 w-full text-center md:text-left  font-montserrat font-extrabold leading-snug tracking-wide text-secondary-500/90 md:mt-0 xxs:text-[3rem] md:text-[2.5rem] lg:text-[2rem] xl:text-[2.5rem] dark:text-lightBlue-200/80">
            FOR VENTURE INVESTING
          </p>
          <p className="mt-4 text-center md:text-left font-semibold leading-snug tracking-wide text-secondary-500 md:text-xl lg:text-2xl dark:text-lightBlue-500">
            <span className="font-semibold text-primary-500">
              Where data meets discipline in VC{' '}<br />
            </span>

          </p>
          <p className="w-[40%] md:w-[80%] mt-8 text-center md:text-left font-medium leading-snug tracking-wide text-secondary-500 md:text-xl lg:text-xl dark:text-lightBlue-500">
            Arcanis Capital applies systematic, data-driven investment strategies to identify high-growth opportunities across global markets.
          </p>
          {/* <p className="w-[40%] md:w-[60%] mt-2 text-center md:text-left font-medium leading-snug tracking-wide text-secondary-500 md:text-xl lg:text-xl dark:text-lightBlue-500">
            Built on our proprietary analytics platform, every decision
            is backed by verifiable data, machine learning models,
            and repeatable methodology.
          </p> */}
          <div className="mt-8 space-x-4">
            <button onClick={() => window.location.href = '#systematicstrategiesforventureinvesting'} className='rounded-lg bg-gradient-to-r from-primary-500 to-primary-600 px-6 py-2 font-semibold text-gray-50 hover:from-primary-300 hover:to-primary-400 hover:text-gray-50'>
              Learn more
            </button>
            <button onClick={() => window.location.href = '#systematicstrategiesforventureinvesting'} className='rounded-lg bg-gradient-to-r from-secondary-500 to-secondary-600 px-6 py-2 font-semibold text-gray-50 hover:from-secondary-300 hover:to-secondary-400 hover:text-gray-50'>
              Request a call
            </button>
          </div>
        </Box>
      </Box>
    </Box >
  );
};
